import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'

export const categoriesStyles = makeStyles((theme: Theme) => ({
    selectLabel: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    text: {
        fontSize: pxToRem(13),
    },

    root: {
        border: 'none',
        paddingLeft: 0,
        paddingBottom: '8px !important',
        '& .MuiAutocomplete-tag': {
            fontSize: pxToRem(13),
        },

        '&:focus': {
            backgroundColor: theme.palette.common.white,
            outline: 'none',
        },
    },
    option: { wordBreak: 'break-word' },
    categoryContainerLeftPane: {
        padding: theme.spacing(2, 0.75, 3.125, 1.75),
    },
    categoriesDiv: {
        minHeight: 500,
        width: '100%',
    },
    headerText: {
        color: theme.palette.primary.dark,
        fontSize: pxToRem(14),
        marginTop: theme.spacing(1.5),
        fontWeight: 500,
        marginBottom: theme.spacing(1),
        textTransform: 'uppercase',
    },
    avatarIconContainerActive: {
        textTransform: 'uppercase',
        textDecoration: 'none',
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.common.white,
        fontWeight: 400,
        fontSize: pxToRem(18),
        width: 35,
        height: 35,
        display: 'inline-flex',
        border: `1px solid ${theme.palette.secondary.main}`,
    },
    avatarIconContainer: {
        textTransform: 'uppercase',
        textDecoration: 'none',
        color: theme.palette.common.white,
        backgroundColor: theme.palette.secondary.main,
        fontWeight: 400,
        fontSize: pxToRem(18),
        width: 35,
        height: 35,
        display: 'inline-flex',
        border: `1px solid ${theme.palette.secondary.main}`,
    },
    categoryItemLeftPane: {
        width: '100%',
        height: 44,
        border: '1px solid #DBDFE0',
        borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0.625),
        backgroundColor: theme.palette.common.white,
        margin: theme.spacing(0, 0, 0.75, 0),
        cursor: 'pointer',
    },
    activeCategoryItem: {
        backgroundColor: '#475E8A',
    },

    categoryImage: {
        width: 35,
        height: 35,
        borderRadius: 50,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
    },
    categoryText: {
        marginLeft: theme.spacing(1.25),
        fontSize: pxToRem(14),
    },
    categoryTextActive: {
        marginLeft: theme.spacing(1.25),
        color: theme.palette.common.white,
        fontSize: pxToRem(14),
    },

    disciplineContainerLeftPane: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
    },
    dropIcon: {
        color: '#000000 54%',
        cursor: 'pointer',
    },
    selectInner: {
        height: 11,
        fontSize: pxToRem(13),
        paddingLeft: '0 !important',
        '&:focus': {
            backgroundColor: theme.palette.common.white,
            outline: 'none',
        },
    },
    selectDisciplineLeftPane: {
        background: theme.palette.common.white,
        border: 'none',
        borderRadius: 4,
        width: 223,
        height: 34,
        fontSize: pxToRem(13),
        '&:focus': {
            backgroundColor: theme.palette.common.white,
            outline: 'none',
        },
    },
}))
